import RouteRegister from "@/plugins/router/services/RouteRegister"
import routers from "@/modules/catalog/routers"

export default {
    install: () => {
        RouteRegister.handle(routers)
    }
}
